import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import ArtFiles from 'pages/staples-art-files/ArtFiles';
import useStaplesArtFiles from 'pages/staples-art-files/context';
import Drawer from '@material-ui/core/Drawer';
import {
  StyledTabs,
  DrawerWrapper,
  Header,
} from 'styles/pages/staples-art-files';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

const ArtFilesTabs = ({
  isDrawer,
  drawerVisibility,
  onClose,
  onSelect,
  deleteArtFile = true,
  searching = true,
  searchDefaultValue,
}) => {
  const { setValue } = useStaplesArtFiles();
  const [selectedTab, setTab] = React.useState(0);

  const Wrapper = () => (
    <StyledTabs>
      <AppBar position="static">
        <Tabs value={selectedTab} onChange={handleChange}>
          <Tab label="Image Files" />
          <Tab label="Embroidery Files" />
        </Tabs>
      </AppBar>
      <TabPanel value={selectedTab} index={0}>
        <ArtFiles
          resourceType="image"
          onSelect={onSelect}
          deleteArtFile={deleteArtFile}
          searching={true}
          searchDefaultValue={searchDefaultValue}
        />
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <ArtFiles
          resourceType="raw"
          onSelect={onSelect}
          deleteArtFile={deleteArtFile}
          searching={true}
          searchDefaultValue={searchDefaultValue}
        />
      </TabPanel>
    </StyledTabs>
  );

  const handleChange = (event, newValue) => {
    setTab(newValue);
    setValue(undefined);
  };

  if (isDrawer) {
    return (
      <Drawer open={drawerVisibility} anchor="right" onClose={onClose}>
        <DrawerWrapper>
          <Header>
            <h1>Staples Art Files</h1>
          </Header>
          <Wrapper />
        </DrawerWrapper>
      </Drawer>
    );
  }

  return <Wrapper />;
};

export default ArtFilesTabs;
